export const GENERATE_INSPECTION_PDF = 'GENERATE_INSPECTION_PDF';
export const GENERATE_INSPECTION_PDF_SUCCESS = 'GENERATE_INSPECTION_PDF_SUCCESS';
export const GENERATE_INSPECTION_PDF_FAILED = 'GENERATE_INSPECTION_PDF_FAILED';
export const START_INSPECTION_PDF_GENERATION = 'START_INSPECTION_PDF_GENERATION';
export const START_INSPECTION_PDF_GENERATION_SUCCESS = 'START_INSPECTION_PDF_GENERATION_SUCCESS';
export const START_INSPECTION_PDF_GENERATION_FAILED = 'START_INSPECTION_PDF_GENERATION_FAILED';
export const CLEAR_INSPECTION_REPORT = 'CLEAR_INSPECTION_REPORT';
